import { useEffect, useState } from 'preact/hooks';

const NAV_EVENT = 'habit-tracker-nav-event';
// Habit tracker uses /?habit-tracker URL pattern
const PREFIX = '?habit-tracker';

function useQueryLocation() {
  const getPath = () => {
    const { search } = window.location;
    if (search.startsWith(PREFIX)) {
      const path = search.slice(PREFIX.length);
      // Split off any query parameters (e.g., /authorize&code=xxx becomes /authorize)
      const pathOnly = path.split('&')[0] || '/';
      return pathOnly;
    }
  };

  const path = getPath();
  const [location, setLocation] = useState(path);

  useEffect(() => {
    const handler = () => {
      const newPath = getPath();
      setLocation(newPath);
    };

    window.addEventListener(NAV_EVENT, handler);
    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener(NAV_EVENT, handler);
      window.removeEventListener('popstate', handler);
    };
  }, []);

  // Clean up URL on initial load - remove ?habit-tracker from visible URL
  useEffect(() => {
    if (window.location.search.startsWith(PREFIX) && location === '/') {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, [location]);

  const navigate = (to, options = {}) => {
    const path = `${window.location.pathname}${PREFIX}${to}`;
    const changer = options.replace ? 'replace' : 'push';

    window.history[`${changer}State`](null, '', path);

    // Dispatch the custom event to trigger re-render
    window.dispatchEvent(new Event(NAV_EVENT));
  };

  return [location, navigate];
}

export default useQueryLocation;
